import { AgentKind, AgentKindProvider } from '@/components/AgentChat/AgentKindProvider'
import { useAskCaiHandoff } from '@/components/AskCai/useAskCaiHandoff'
import { useCaiDocked } from '@/components/sidebar'
import { Button } from '@/components/ui/button'

function Inner({ prompt }: { prompt: string }) {
  const { prefill, isPending } = useAskCaiHandoff()
  return (
    <Button
      variant="outline"
      size="xs"
      loading={isPending ? 'Opening…' : undefined}
      onClick={() => void prefill(prompt)}
    >
      Ask Cai
    </Button>
  )
}

/** Opens Ask Cai with the vault's ask already typed, so the carrier only attaches and sends. */
export function VaultAskCaiButton({ prompt }: { prompt: string }) {
  if (useCaiDocked()) return null
  return (
    <AgentKindProvider kind={AgentKind.ASK_CAI}>
      <Inner prompt={prompt} />
    </AgentKindProvider>
  )
}
